import { Pipe, PipeTransform } from '@angular/core';
import { formatAccountType } from '../_helpers/enum-label.helper';
import { AccountType } from '../enum/accounttype.enum';

@Pipe({
    name: 'accountTypeLabel',
    standalone: false
})
export class AccountTypeLabelPipe implements PipeTransform {
  transform(value: AccountType | number | null | undefined): string {
    return formatAccountType(value);
  }
}